import * as React from 'react';
import type { SVGProps } from 'react';
const SvgFileCardRotate = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fill="currentColor"
      d="M14.484 7h.266c.416 0 .75-.334.75-.75v-4a.749.749 0 0 0-1.281-.531l-1.3 1.3a7 7 0 0 0-9.869.031 7 7 0 0 0 0 9.9 7 7 0 0 0 9.9 0 1.002 1.002 0 0 0-1.416-1.416 5 5 0 1 1-7.071-7.071 5 5 0 0 1 7.04-.032L10.22 5.72A.751.751 0 0 0 10.75 7z"
    />
  </svg>
);
export default SvgFileCardRotate;
